// extracted by mini-css-extract-plugin
module.exports = {"do":"TaskDo_do__DhBP0","do__content":"TaskDo_do__content__2vOeM","do__icon":"TaskDo_do__icon__1QNRT","triangle":"TaskDo_triangle__TFs_K"};